const invoicesDE = {
    "view": {
        "table": {
            "title": "Ihre Rechnungen Liste",
            "column": {
                "issueDate": "Ausstellungsdatum",
                "invoiceNumber": "Rechnungsnummer",
                "status": "Status",
                "totalAmount": "Gesamtbetrag",
                "downloadPDF": "PDF herunterladen",
                "whtStatement": "WHT-Erklärung"
            },
            "label": {
                "notApplicable": "Nicht zutreffend"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "button": {
                "download": "Herunterladen",
                "exportCSV": "CSV exportieren"
            }
        },
        "message": {
            "cantAddInvoices": "Leider können Sie derzeit keine Rechnungen hinzufügen. Entweder sind Ihre Steuer- oder Zahlungsdaten nicht vollständig. Um diese Funktion freizuschalten, kontaktieren Sie bitte unser Support-Team.",
            "invoicingNotAvailable": "Generieren Sie Rechnungen vom 3. bis zum 22. jedes Monats. Bitte beachten Sie, dass die Rechnungserstellung nicht möglich ist vom 23. bis zum 2. des Folgemonats, da während dieses Zeitraums automatische Zahlungen verarbeitet werden. Vielen Dank für Ihr Verständnis.",
            "generatingInvoices": "Sie können derzeit keine Rechnungen hinzufügen, da Rechnungen gerade erstellt werden. Bitte versuchen Sie es später erneut.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen."
        }
    },
    "add": {
        "title": "Rechnung hinzufügen",
        "form": {
            "table": {
                "statements": {
                    "title": "Erklärungen verfügbar für die Rechnungsstellung"
                }
            },
            "button": {
                "generateInvoice": "Rechnung erstellen"
            }
        },
        "message": {
            "success": "Rechnung wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "noStatementAvailable": "Keine Erklärung für die Rechnungsstellung verfügbar.",
            "invoicingLimitNotReached": "Sie können derzeit keine Rechnungen hinzufügen, da der Gesamtbetrag der zu zahlenden Summe kleiner oder gleich <strong>0€</strong> ist."
        },
        "modal": {
            "header": "Rechnung hinzufügen",
            "body": "Sind Sie sicher, dass Sie eine Rechnung für derzeit OFFENE Erklärungen erstellen möchten?"
        }
    }
};

export default invoicesDE;